import React from "react";
import { Container, Typography, Box, Grid } from "@mui/material";
import car from "../../../../assets/images/car_entry_exit.png";
import bgImg from "../../../../assets/images/sLOTS_bg.svg";
import useAvailableSlot from "../../hooks/useAvailableSlot";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";

const AvailableSlotsForCars = () => {
  const { slotCount, vehicleDetails } = useAvailableSlot();

  return (
    <>
      <div
        className="background-fixed"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <Container
          xs={12}
          md={12}
          sm={12}
          fullWidth
          sx={{
            height: "100vh",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div className="flex justify-center items-center w-full h-screen">
            <div className="flex w-full h-full flex-col items-center justify-center">
              <div className="text-[white] tracking-wider text-[5rem] font-bold">
                AVAILABLE SLOTS
              </div>

              <div className="text-[white] text-[25rem] font-black">
                {slotCount?.available ?? "0"}
              </div>
            </div>

            {vehicleDetails?.imageUrl ? (
              <img
                style={{ width: "350px", height: "auto" }}
                src={vehicleDetails.imageUrl}
                alt="/"
              />
            ) : (
              <AirportShuttleIcon sx={{ fontSize: "13rem", color: "white" }} />
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

export default AvailableSlotsForCars;
